module.exports = __webpack_public_path__ + "static/img/recruit-content.983c1a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/recruit-content.jpg
// module id = RX/3
// module chunks = 0